import { render } from "./EditPointsBottomMenu.vue?vue&type=template&id=74e51c0a&scoped=true"
import script from "./EditPointsBottomMenu.vue?vue&type=script&lang=js"
export * from "./EditPointsBottomMenu.vue?vue&type=script&lang=js"

import "./EditPointsBottomMenu.vue?vue&type=style&index=0&id=74e51c0a&lang=scss&scoped=true"

import exportComponent from "/home/esesja/domains/app.esesja.mda.pl/public_html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e51c0a"]])

export default __exports__